import { DocumentApproval } from "./../../DocumentApprovals/index";
import { UserData } from "./../../Users/index";
import { Name } from "../../common";
import { Block } from "../../ProposalBuilder/Block";
import { QuoteTotal } from "../index";

export class DocumentDefaults {
	font_color = "";
	font_face = "";
	font_size = "";
}

export class RevisionSigner {
	email = "";
	requester_id = "";
	requester_name: Name = new Name();
	signed = false;
	assigned_sign_blocks: string[] | null = new Array<string>();
}

export class SignatureDetails {
	signers: RevisionSigner[] = new Array<RevisionSigner>();
}

export enum ApprovalStatus {
	RequestSent = "request_sent",
	Approved = "approved",
	Rejected = "rejected"
}

export enum ApprovalOption {
	Approve = "approve",
	Reject = "reject"
}

export interface ApprovalDetails {
	readonly approval_status: null | ApprovalStatus;
	readonly approved_at: null | Date;
	readonly approved_by_user: null | UserData;
	readonly approved_by_user_id: null | string;
	readonly comments: string;
	readonly rejected_at: null | Date;
	readonly rejected_by_user: null | UserData;
	readonly rejected_by_user_id: null | string;
}

export interface ApprovalStatusResponse {
	readonly approval_required: boolean;
	readonly approval_required_rules: DocumentApproval[] | null;
	readonly approval_details: ApprovalDetails;
}

export interface DocumentTotal {
	one_time: number;
	weekly: number;
	monthly: number;
	quarterly: number;
	semi_annually: number;
	annual: number;
	grand: number;
	one_time_cost: number;
	weekly_cost: number;
	monthly_cost: number;
	quarterly_cost: number;
	semi_annually_cost: number;
	annual_cost: number;
	grand_cost: number;
	total_cost: number;
	total_revenue: number;
	margin_value: number;
	margin_percentage: number;
}

export enum HeaderFooterColumnTypes {
	PAGE_NUMBER = "page_number",
	IMAGE = "image",
	TEXT = "text"
}

export interface HeaderFooterColumnData {
	page_no?: string | null;
	image_url?: string;
	text?: string;
	background_color?: string;
}

export interface HeaderFooterColumnDetails {
	data_type: HeaderFooterColumnTypes;
	data: HeaderFooterColumnData;
}

export interface HeaderFooterDetails {
	columns: (HeaderFooterColumnDetails | null)[];
}

export interface MarginSettings {
	top: number;
	bottom: number;
	left: number;
	right: number;
}

export interface DocumentPageDetails {
	header?: HeaderFooterDetails | null;
	footer?: HeaderFooterDetails | null;
	pdf_blocks?: string[];
	margin?: MarginSettings | null;
}

export interface DocumentRevision {
	block_list: string[];
	draft_block_list?: string[];
	blocks?: { data: Block[] };
	draft_blocks?: { data: Block[] };
	revision_id: string;
	updated: Date;
	signature_details?: SignatureDetails;
	defaults: DocumentDefaults;
	approval_details: ApprovalDetails;
	total?: QuoteTotal;
	page_details?: DocumentPageDetails;
	rich_text_block_id?: string;
	rich_text_block?: Block | null;
}

export interface DocumentWonUrlResponse {
	url: string;
}
